import React, { Component } from 'react';
import _ from 'lodash';
import axios from 'axios';
import { Divider, Card, Statistic, Icon, Button } from 'semantic-ui-react';
import PlainReport from 'dyzio-shared-components/lib/reports/plain-report';

import ReportHeader from '../../components/report-header';
import ReportHeroContent from '../../components/report-hero-content';
import UserDetailsModal from '../../components/user-details-modal';

const REPORT_TIMEOUT = 50000;
const IS_PRODUCTION = process.env.NODE_ENV === 'production';
const PROFILE_KEY = 'DYZIO_PROFILE';

const skyData = require('./data/sky-westworld').reportData;
const accorData = require('./data/accor-hotels').reportData;

const SKY_WESTWORLD_CAMPAIGN_ID = '52453576-3915-4d0e-95cf-bafc4f5ffaf7';
const ACCOR_HOTELS_ID = 'fc25e7e5-db92-4aa3-8676-e90f4945583d';
const reports = {
  'sky-westworld': {
    id: SKY_WESTWORLD_CAMPAIGN_ID,
    data: skyData,
    support: {
      name: 'Calfreezy',
      discussionName: 'Calfreezy',
      showSummary: true,
    },
  },
  'callux-accor-hotels': {
    id: ACCOR_HOTELS_ID,
    data: accorData,
    support: {
      name: 'Sarah',
      discussionName: 'SarahClose1',
      showSummary: false,
    },
  },
};


class CampaignReport2 extends Component {
  constructor() {
    super();
    this.state = { profile: null };

    this.reportClient = axios.create({
      baseURL: process.env.REACT_APP_REPORT_API_URL,
      timeout: REPORT_TIMEOUT,
      headers: {
        Authorization: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhcHBfbWV0YWRhdGEiOnsicm9sZXMiOlsidXNlciJdLCJkeXppbyI6eyJ1X2lkIjoiZGVhNDVhMmMtYWQ0MS00OGQ2LWIxYjQtOGFlZjQ1NjZjNGZiIiwibmFtZSI6IkRhbiBDYW50aXIiLCJlbWFpbCI6ImRhbi5jYW50aXJAYXRvbWF0ZS5uZXQiLCJvX2lkIjoiZjE0ZDM5MzEtMGU2YS00MmU4LWFkM2MtYWUyZmYwN2UzZDk2Iiwicm9sZSI6IlRFQU1fTUVNQkVSIiwidmVyc2lvbiI6MX19LCJpc3MiOiJodHRwczovL2R5emlvLmV1LmF1dGgwLmNvbS8iLCJzdWIiOiJhdXRoMHw1OGI1NmMxYmIzM2M1NTQ2Nzg3YWE0NTYiLCJhdWQiOiJNeHVFWmthWHF1Wm5sSmVMOW9FOFFoeVF6aE10amZUcCIsImlhdCI6MTUwOTcwNzU2NCwiZXhwIjoxNTA5NzQzNTY0fQ.sIKlNtois5uMAKWrGD4tsfiNtT7JsqSnamFVRmRFXmg',
      },
    });

    this.client = axios.create({
      baseURL: process.env.REACT_APP_NOTIFY_API_URL,
      timeout: 2000,
      headers: {
        Authorization: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhcHBfbWV0YWRhdGEiOnsicm9sZXMiOlsidXNlciJdLCJkeXppbyI6eyJ1X2lkIjoiZGVhNDVhMmMtYWQ0MS00OGQ2LWIxYjQtOGFlZjQ1NjZjNGZiIiwibmFtZSI6IkRhbiBDYW50aXIiLCJlbWFpbCI6ImRhbi5jYW50aXJAYXRvbWF0ZS5uZXQiLCJvX2lkIjoiZjE0ZDM5MzEtMGU2YS00MmU4LWFkM2MtYWUyZmYwN2UzZDk2Iiwicm9sZSI6IlRFQU1fTUVNQkVSIiwidmVyc2lvbiI6MX19LCJpc3MiOiJodHRwczovL2R5emlvLmV1LmF1dGgwLmNvbS8iLCJzdWIiOiJhdXRoMHw1OGI1NmMxYmIzM2M1NTQ2Nzg3YWE0NTYiLCJhdWQiOiJNeHVFWmthWHF1Wm5sSmVMOW9FOFFoeVF6aE10amZUcCIsImlhdCI6MTUwOTcwNzU2NCwiZXhwIjoxNTA5NzQzNTY0fQ.sIKlNtois5uMAKWrGD4tsfiNtT7JsqSnamFVRmRFXmg',
      },
    });
  }

  getProfile = () => {
    // Retrieves the profile data from localStorage
    const profile = localStorage.getItem(PROFILE_KEY);
    return profile ? JSON.parse(profile) : null;
  }

  componentDidMount = () => {
    const profile = this.getProfile();
    console.log(`[PROFILE_KEY]: ${profile}`);

    const { name } = this.props.match.params;
    console.log(name);

    const report = reports[_.toLower(name)];
    const { data, id, support } = report;

    this.setState({
      profile,
      data,
      id,
      support,
    }, () => {
      this.fetchReport();
      this.notify();
    });
  }

  setProfile = profile => {
    console.log(`[setProfile]: ${profile}`);

    localStorage.setItem(PROFILE_KEY, JSON.stringify(profile));
    this.setState({
      profile,
    }, this.notify);
  }

  fetchReport = () => {
    const { id } = this.state;
    const type = 'basic';

    const reportParams = {
      id,
      type,
    };

    console.log(reportParams);

    this.reportClient.post('/', reportParams).then(response => {
      const { data } = response;

      console.log(data);

      const posts = _.filter(data.data.posts, (
        post => !_.isNull(post)
        && !_.isUndefined(post.trackedAsset)
        && (post.trackedAsset.platform !== 'YOUTUBE')
      ));
      data.data.posts = posts;

      const campaign = {
        name: data.data.name,
      };

      this.setState({
        liveData: data,
        id,
        type,
        loading: false,
        campaign,
      }, this.notify);
    }).catch(error => {
      console.log('FETCH REPORT ERROR!');
      console.log(error);
    });
  }

  notify = () => {
    const { profile, data } = this.state;
    const { href } = window.location;

    if (profile) {
      const campaign = {
        name: data.info.campaignName,
      };
      const notification = {
        data: {
          profile,
          campaign,
          href,
        },
      };
      console.log(notification);

      if (IS_PRODUCTION) {
        this.client.post('/', notification)
          .then(() => console.log('notified OK.'))
          .catch(e => console.log(e));
      }
    }
  }

  render = () => {
    const selectedInfluencer = {
      discussionName: 'Callux',
      name: 'Callux',
    };

    const { name } = this.props.match.params;
    const { profile, data, liveData, support } = this.state;
    const isProfileSet = Boolean(profile);

    let influencerPosts;
    let supportingPosts;
    const postsDto = { data: {} };
    const supportingPostsDto = { data: {} };

    if (liveData) {
      const { posts } = liveData.data;
      console.log(selectedInfluencer.discussionName);
      influencerPosts = _.filter(posts, (
        post => (post.trackedAsset.discussionName === selectedInfluencer.discussionName)
      ));

      supportingPosts = _.filter(posts, (
        post => (post.trackedAsset.discussionName === support.discussionName)
      ));

      postsDto.data.posts = _.orderBy(influencerPosts, 'platform');
      supportingPostsDto.data.posts = _.orderBy(supportingPosts, 'platform');
    }

    const x = {
      sort: 'values.totals.followersCount',
      groupBy: 'influencer',
      order: {
        basic: {
          field: null,
          value: null,
        },
      },
      filter: {
        basic: {
          platform: null,
          handle: null,
        },
      },

    };


    if (data) {
      console.log('[CampaignReport]');
      console.log(name);

      return (
        <div>
          <UserDetailsModal open={!isProfileSet} successHandler={this.setProfile} />
          <ReportHeader info={data.info} />
          <div>
            <Divider />
            <ReportHeroContent mainData={data.heroData.main} />
            <Card fluid>
              <Card.Content>
                <Card.Header>
                  Supporting social activity
                </Card.Header>
                <Card.Meta>
                  { selectedInfluencer.name }&apos;s supporting posts on other social networks
                </Card.Meta>
              </Card.Content>
              { liveData && <PlainReport data={postsDto} filter={x.filter} sort={x.sort} order={x.order} /> }

            </Card>

            <Card fluid>
              <Card.Content>
                <Card.Header>
                  {support.name}&apos;s supporting activity
                </Card.Header>
                <Card.Meta>
                  {support.name}&apos;s supporting posts on other social networks
                </Card.Meta>
              </Card.Content>
              { liveData && <PlainReport data={supportingPostsDto} filter={x.filter} sort={x.sort} order={x.order} /> }

            </Card>

            { liveData && support.showSummary &&

              <Card color="pink" fluid>
                <Card.Content>
                  <Card.Header>
                    Campaign Summary (all channels)
                  </Card.Header>
                  <Card.Meta>
                    Total impressions, views and enagagements. All channels and all influencers.
                  </Card.Meta>
                </Card.Content>
                <Card.Content>
                  <Statistic.Group widths="four">
                    <Statistic>
                      <Statistic.Value>961k</Statistic.Value>
                      <Statistic.Label>impressions</Statistic.Label>
                    </Statistic>

                    <Statistic>
                      <Statistic.Value>
                        878k
                      </Statistic.Value>
                      <Statistic.Label><Icon name="youtube play" />views</Statistic.Label>
                    </Statistic>

                    <Statistic>
                      <Statistic.Value>
                        48k
                      </Statistic.Value>
                      <Statistic.Label>engagements</Statistic.Label>
                    </Statistic>

                    <Statistic>
                      <Statistic.Value>
                        2.6m
                      </Statistic.Value>
                      <Statistic.Label>minutes (total watch time)</Statistic.Label>
                    </Statistic>
                  </Statistic.Group>

                </Card.Content>

                <Card.Content textAlign="center">
                  {
                    data && data.info.campaignArchive &&
                    <div>
                      <h4>download all supporting screenshots here!</h4>
                      <Button
                        massive content="Download Files" icon="download" color="pink" onClick={() => {
                          window.open(data.info.campaignArchive, '_blank');
                        }}
                      />
                    </div>
                  }
                </Card.Content>
                <Card.Content textAlign="center">
                  <a
                    rel="noopener noreferrer"
                    href="https://dyzio.co"
                    target="_blank"
                  >
                    influencer analytics - powered by dyzio
                  </a>
                </Card.Content>
              </Card>
            }

            <br />
            <br />
          </div>
        </div>
      );
    }

    return (
      <div>could not find your report</div>
    );
  };
}
export default CampaignReport2;



// WEBPACK FOOTER //
// ./src/containers/campaign-report2/index.js